var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("h1", { staticClass: "title-text" }, [
    _vm._v(
      "\n    " +
        _vm._s(
          _vm.getResidentialHouseTypeName !==
            _vm
              .$t("messages_nl.rental.typePluralOrNot.residentialHouse", {
                count: 1,
              })
              .toLowerCase()
            ? _vm.capitalizeFirstLetter(
                _vm.$t("messages_nl.catalog.h1Alternative", {
                  rentalType: _vm.getResidentialHouseTypeName,
                  location: _vm.location,
                })
              )
            : _vm.$t("messages_nl.rental.typePluralOrNot.residentialHouse", {
                count: 0,
              }) +
                " " +
                _vm.location
        ) +
        "\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }